import {
  CompaniesList,
  CompanyCreate,
  CompanyEdit,
  CompanyShow
} from 'pages/certificates_management/companies';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'companies',
  label: 'Unidades',
  list: CompaniesList,
  create: CompanyCreate,
  edit: CompanyEdit,
  show: CompanyShow,
  actions: ['list', 'show', 'create', 'edit'],
  parentName: 'certificate_management'
};

export default generateResources(resource);
